export class DeviceUtils {

  public static get isTouchDevice(): boolean {
    if (typeof window === 'undefined' || typeof matchMedia !== 'function') {
      return false;
    }

    if (matchMedia('(hover: none)').matches) {
      return true;
    }

    if (matchMedia('(pointer: coarse)').matches) {
      return true;
    }

    if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
      if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
        return false;
      }

      return true;
    }

    return false;
  }

  public static get isIOS(): boolean {
    return navigator.userAgent.includes('Mac') || navigator.userAgent.includes('iPad');
  }

  public static isCtrlOrCmdClick(event: MouseEvent): boolean {
    if (DeviceUtils.isIOS) {
      return event.metaKey;
    }

    if (event.getModifierState('AltGraph')) {
      return false;
    }

    return event.ctrlKey && !event.altKey;
  }
}
